(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventStatus', EventStatus);

    EventStatus.$inject = ['$resource'];

    function EventStatus ($resource) {
        var resourceUrl =  'api/event-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
